const orderStatuses = {
    tabs: {
        basic: 'Order statuses',
        payment: 'Payment statuses'
    },
    title: 'Order statuses',
    formsTable: {
        title: "Order statuses",
        headers: {
            name: 'Name',
            description: 'Description',
            erpOrderStatusName: 'Name from ERP'
        },
        tooltips: {
            edit: 'Edit order status',
        },
        editModal: {
            title: 'Editing the order status',
            inputs: {
                name: 'Name',
                description: 'Description',
                erpOrderStatusId: 'Order status from ERP system',
                color: 'Color',
                colorButton: 'Select',
            },
            buttons: {
                remove: 'BACK',
                save: 'SAVE'
            },
            nameModalHeader: 'Editing the order status name',
            descriptionModalHeader: 'Edit order status description'
        }
    },
    paymentRulesTable: {
        title: 'Payment status mapping rules',
        headers: {
            name: 'Name',
            previousPaymentStatus: 'Previous payment status',
            paymentStatus: 'Payment status',
            currentOrderStatus: 'Current order status',
            targetOrderStatus: 'Target order status',
            priority: 'Priority',
            enabled: 'Enabled',
            actions: 'Actions'
        },
        tooltips: {
            add: 'Add rule',
            edit: 'Edit rule'
        },
        buttons: {
            create: 'ADD'
        },
        deleteModal: {
            header: 'Delete rule',
            body: 'Are you sure you want to delete selected rule?',
            confirm: 'Delete',
            cancel: 'Back'
        },
        editModal: {
            title: 'Edit mapping rule',
            labels: {
                name: 'Name',
                previousPaymentStatus: 'Previous payment status',
                paymentStatus: 'Payment status',
                currentOrderStatus: 'Current order status',
                orderStatus: 'Target order status',
                priority: 'Priority',
                enabled: 'Enabled'
            },
            buttons: {
                confirm: 'SAVE',
                cancel: 'CANCEL'
            }
        },
        errors: {
            paymentStatusRequired: 'Please select payment status.',
            orderStatusRequired: 'Please select target order status.'
        }
    }
};

export default orderStatuses;